@if (isChatbotVisible) {
    <div
        class="fixed right-0 top-1/2 z-[1200] -translate-y-1/2 flex items-center gap-2 pointer-events-none pb-[env(safe-area-inset-bottom)] max-mobileHint:left-1/2 max-mobileHint:right-auto max-mobileHint:top-auto max-mobileHint:bottom-0 max-mobileHint:-translate-x-1/2 max-mobileHint:translate-y-0 max-mobileHint:flex-col max-mobileHint:gap-0">
        @if (isOpen) {
            <section
                class="w-[40rem] max-w-[94vw] h-auto max-h-[90vh] max-mobileHint:w-[calc(100vw-0.5rem)] max-mobileHint:max-w-[calc(100vw-0.5rem)] max-mobileHint:max-h-[calc(100dvh-2.5rem)] mr-1 mb-0 max-mobileHint:mb-1 max-mobileHint:mr-0 border border-slate-300 dark:border-slate-700 rounded-xl max-mobileHint:rounded-lg bg-white dark:bg-gray-800 shadow-[0_8px_30px_rgba(15,23,42,0.18)] flex flex-col overflow-hidden pointer-events-auto">
                <header class="shrink-0 flex justify-between items-center pt-4 px-5 pb-3 border-b-2 border-solid border-blue dark:border-black-700">
                    <div class="inline-flex items-center gap-2 text-xl text-blue font-medium">
                        <img
                            src="/assets/img/ai_chatbot/okapi_thinking.png"
                            [attr.alt]="'AI_CHATBOT.UI.IMAGE_ALT' | translate"
                            class="h-8 w-8 rounded-full object-cover border border-slate-200 dark:border-slate-600" />
                        <span>{{ 'AI_CHATBOT.UI.TITLE' | translate }}</span>
                        @if (isSending) {
                            <span class="text-xs font-semibold text-blue dark:text-blue-300">{{ 'AI_CHATBOT.UI.GENERATING' | translate }}</span>
                        }
                        @if (useAzureMock) {
                            <span class="inline-flex items-center rounded-full px-2 py-0.5 text-[0.72rem] leading-[1.1] bg-amber-500 text-gray-900 font-bold">{{
                                'AI_CHATBOT.UI.MOCK_BADGE' | translate
                            }}</span>
                        }
                    </div>
                    <div class="ml-4 inline-flex items-center gap-2">
                        <button
                            type="button"
                            class="flex items-center justify-center rounded border-2 border-solid border-blue text-blue hover:bg-blue-100 dark:hover:bg-black-700 transition-colors duration-100 w-11 h-11 disabled:opacity-50 disabled:cursor-not-allowed"
                            [attr.aria-label]="'AI_CHATBOT.UI.NEW_CHAT_BUTTON' | translate"
                            [attr.title]="'AI_CHATBOT.UI.NEW_CHAT_BUTTON' | translate"
                            [disabled]="isSending"
                            (click)="startNewChat()">
                            <je-fa-icon [name]="'comment-plus'" [size]="'small'"></je-fa-icon>
                        </button>
                        <button
                            type="button"
                            class="flex items-center justify-center rounded border-2 border-solid border-black-900 text-blue hover:bg-blue-100 dark:hover:bg-black-700 transition-colors duration-100 w-11 h-11"
                            (click)="close()">
                            <je-fa-icon [name]="'xmark'" [size]="'small'"></je-fa-icon>
                        </button>
                    </div>
                </header>

                <div class="shrink-0 px-5 pt-3">
                    <je-message-box [type]="'info'" [compact]="true">
                        {{ 'AI_CHATBOT.UI.WARNING' | translate }}
                    </je-message-box>
                </div>

                <div
                    class="overflow-y-auto overscroll-contain px-5 py-4 flex flex-col gap-2.5 min-h-[12rem] max-h-[calc(90vh-12rem)] max-mobileHint:max-h-[calc(100dvh-14.5rem)]"
                    #messagesContainer
                    (scroll)="onMessagesScroll()">
                    @for (message of messages; track $index) {
                        <div
                            class="max-w-[88%] flex flex-col gap-1"
                            [ngClass]="{
                                'self-end items-end': message.role === 'user',
                                'self-start items-start': message.role === 'assistant',
                                'self-center items-center': message.role === 'system',
                            }">
                            @if (message.role === 'user') {
                                <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-blue-700 dark:text-blue-300">{{
                                    'AI_CHATBOT.UI.ROLE.USER' | translate
                                }}</span>
                            } @else if (message.role === 'assistant') {
                                <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-slate-600 dark:text-slate-300">{{
                                    'AI_CHATBOT.UI.ROLE.ASSISTANT' | translate
                                }}</span>
                            } @else {
                                <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-red-700 dark:text-red-300">{{
                                    'AI_CHATBOT.UI.ROLE.SYSTEM' | translate
                                }}</span>
                            }

                            <div
                                class="w-fit rounded-xl px-3 py-2 text-[0.9rem] leading-[1.3] break-words border"
                                [ngClass]="{
                                    'bg-blue-100 text-slate-900 border-blue-200 dark:bg-blue-700 dark:text-slate-50 dark:border-blue-500 rounded-tr-sm whitespace-pre-wrap':
                                        message.role === 'user',
                                    'bg-gray-100 text-black-900 border-gray-400 dark:bg-black-700 dark:text-white dark:border-black-500 rounded-tl-sm whitespace-normal':
                                        message.role === 'assistant',
                                    'bg-red-50 text-red-800 border-red-200 dark:bg-red-950/70 dark:text-red-200 dark:border-red-800 whitespace-pre-wrap': message.role === 'system',
                                }">
                                @if (message.role === 'assistant') {
                                    <div
                                        class="[&_p]:my-2 [&_p]:leading-[1.45] [&_strong]:font-semibold [&_i]:text-gray-700 dark:[&_i]:text-gray-300 [&_h1]:mt-3 [&_h1]:mb-2 [&_h1]:text-[1.125rem] [&_h1]:leading-6 [&_h1]:font-semibold [&_h1]:text-blue dark:[&_h1]:text-blue-300 [&_h2]:mt-3 [&_h2]:mb-1.5 [&_h2]:text-[1rem] [&_h2]:leading-5 [&_h2]:font-semibold [&_h2]:text-blue dark:[&_h2]:text-blue-300 [&_h3]:mt-2.5 [&_h3]:mb-1 [&_h3]:text-[0.9rem] [&_h3]:leading-5 [&_h3]:font-semibold [&_h3]:text-blue dark:[&_h3]:text-blue-300 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-1 [&_table]:my-3 [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:border-gray-400 dark:[&_td]:border-black-500 [&_td]:px-2 [&_td]:py-1.5 [&_td]:align-top [&_tr]:even:bg-white/70 dark:[&_tr]:even:bg-black-800"
                                        [innerHTML]="message.text"></div>
                                } @else {
                                    {{ message.text }}
                                }
                            </div>
                        </div>
                    }

                    @if (isOrderContextConsentPending) {
                        <div class="max-w-[88%] self-start items-start flex flex-col gap-1">
                            <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-slate-600 dark:text-slate-300">{{
                                'AI_CHATBOT.UI.ROLE.ASSISTANT' | translate
                            }}</span>
                            <div
                                class="w-fit rounded-xl rounded-tl-sm px-3 py-2 text-[0.9rem] leading-[1.3] bg-gray-100 text-black-900 border border-gray-400 dark:bg-black-700 dark:text-white dark:border-black-500">
                                <div class="inline-flex flex-wrap gap-2">
                                    <button
                                        type="button"
                                        class="rounded-md border border-blue-600 bg-blue-600 text-white px-2.5 py-1.5 text-[0.8rem] font-semibold hover:bg-blue-700 transition-colors"
                                        (click)="setOrderContextConsent(true)">
                                        {{ 'AI_CHATBOT.UI.CONSENT.YES' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="rounded-md border border-gray-400 bg-white text-black-900 px-2.5 py-1.5 text-[0.8rem] font-semibold hover:bg-gray-100 transition-colors dark:bg-black-800 dark:text-gray-100 dark:border-black-600 dark:hover:bg-black-700"
                                        (click)="setOrderContextConsent(false)">
                                        {{ 'AI_CHATBOT.UI.CONSENT.NO' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                    @if (isSending) {
                        <div class="w-[88%] self-start items-start flex flex-col gap-1">
                            <span class="text-[0.7rem] font-semibold uppercase tracking-wide text-slate-600 dark:text-slate-300">{{
                                'AI_CHATBOT.UI.ROLE.ASSISTANT' | translate
                            }}</span>
                            <div
                                class="relative w-full min-h-[4rem] rounded-xl rounded-tl-sm px-3 py-2 pr-14 text-[0.9rem] leading-[1.3] whitespace-normal break-words bg-gray-100 text-black-900 border border-gray-400 dark:bg-black-700 dark:text-white dark:border-black-500">
                                @if (streamingAssistantText) {
                                    <div
                                        class="[&_p]:my-2 [&_p]:leading-[1.45] [&_strong]:font-semibold [&_i]:text-gray-700 dark:[&_i]:text-gray-300 [&_h1]:mt-3 [&_h1]:mb-2 [&_h1]:text-[1.125rem] [&_h1]:leading-6 [&_h1]:font-semibold [&_h1]:text-blue dark:[&_h1]:text-blue-300 [&_h2]:mt-3 [&_h2]:mb-1.5 [&_h2]:text-[1rem] [&_h2]:leading-5 [&_h2]:font-semibold [&_h2]:text-blue dark:[&_h2]:text-blue-300 [&_h3]:mt-2.5 [&_h3]:mb-1 [&_h3]:text-[0.9rem] [&_h3]:leading-5 [&_h3]:font-semibold [&_h3]:text-blue dark:[&_h3]:text-blue-300 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-1 [&_table]:my-3 [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:border-gray-400 dark:[&_td]:border-black-500 [&_td]:px-2 [&_td]:py-1.5 [&_td]:align-top [&_tr]:even:bg-white/70 dark:[&_tr]:even:bg-black-800"
                                        [innerHTML]="streamingAssistantText"></div>
                                    <span class="inline-flex items-end gap-1 leading-none text-lg ml-1">
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 0 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 1 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 2 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                    </span>
                                } @else {
                                    <span class="inline-flex items-end gap-1 leading-none text-lg">
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 0 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 1 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                        <span class="transition-all duration-150 ease-out" [ngClass]="processingDotIndex === 2 ? 'scale-125 opacity-100' : 'scale-90 opacity-55'">
                                            .
                                        </span>
                                    </span>
                                }

                                <button
                                    type="button"
                                    class="absolute z-10 top-2 right-2 inline-flex items-center justify-center h-8 w-8 rounded-md border border-red bg-red text-white hover:bg-red-600 hover:border-red-600 transition-colors duration-100"
                                    [attr.aria-label]="'AI_CHATBOT.UI.STOP_STREAM' | translate"
                                    [attr.title]="'AI_CHATBOT.UI.STOP_STREAM' | translate"
                                    [disabled]="!isSending"
                                    [ngClass]="{ 'opacity-50 cursor-not-allowed': !isSending }"
                                    (click)="stopStreaming()">
                                    <je-fa-icon [name]="'stop'" [size]="'small'" [variant]="'contrast'"></je-fa-icon>
                                </button>
                            </div>
                        </div>
                    }
                </div>

                <div class="shrink-0 border-t border-black-200 dark:border-black-700 px-5 py-3">
                    <je-input-group class="w-full">
                        <bsm-textarea
                            [value]="draftMessage"
                            (valueChange)="draftMessage = $event"
                            [disabled]="isInputDisabled"
                            [minRows]="2"
                            class="w-full mb-0"
                            (keydown)="onInputKeydown($event)"></bsm-textarea>
                        <je-button
                            actions
                            [label]="'AI_CHATBOT.UI.SEND' | translate"
                            [disabled]="isInputDisabled || !draftMessage.trim()"
                            variant="primary"
                            (onClick)="sendMessage()"
                            class="ml-2">
                        </je-button>
                    </je-input-group>
                </div>
            </section>
        }

        <button
            #dockPulseTarget
            type="button"
            class="border border-blue-600 border-r-0 rounded-l-[10px] bg-blue-600 text-white px-3 py-2 min-h-11 w-[4.5rem] inline-flex items-center justify-center cursor-pointer pointer-events-auto max-mobileHint:border-r max-mobileHint:border-b-0 max-mobileHint:rounded-l-none max-mobileHint:rounded-t-[10px]"
            [attr.aria-label]="dockAriaLabel"
            (click)="toggleOpen()">
            <span class="relative inline-flex items-center justify-center">
                <img
                    src="/assets/img/ai_chatbot/okapi_thinking.png"
                    [attr.alt]="'AI_CHATBOT.UI.IMAGE_ALT' | translate"
                    class="h-9 w-9 rounded-full object-cover border border-white/70 bg-[#e5eef7]" />
            </span>
        </button>
    </div>
}
